import { useContext, useEffect, useState } from "react";

import { GeneralContext, MixPanelContext, ModalContext } from "~/contexts";
import api from "~/services/api";
import dates from "~/utils/dates";
import FormBill from '~/pages/Bills/Form';
import icon from './images/icon.svg';
import Button from '~/components/Parts/Forms/Button';
import { RiLoader2Line } from "react-icons/ri";
import { FaDownload, FaPlus, FaTrash } from "react-icons/fa";

const BillHistoryBox: React.FC<any> = (props: any) => {
    const { user }                  = useContext(GeneralContext);
    const Modal                     = useContext(ModalContext);
    const [downReady, setDownReady] = useState<Boolean>(true);
    const dateFormatCreate          = dates._getDateByDate(props.Bill.created_at);


    function downloadPDF(path: string) {
        setDownReady(false);

        api.get(`bill/${path}`, {
            headers: { Authorization: user.token },
            responseType: 'blob'
        }).then(resp => {
            let url = window.URL.createObjectURL(new Blob([resp.data]));
            let link = document.createElement('a');
            let fileName = `${props.companyName ? props.companyName : 'Sem Nome'} - ${dateFormatCreate.monthName} de ${dateFormatCreate.year}.pdf`;

            setTimeout(() => {
                link.href = url;
                link.setAttribute("id", "download");
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                setDownReady(true);
            }, 1000);
        })
    }

    return <>
        <div className="client">
            {props.companyName}
        </div>
        <div className="provider">
            {props.Bill.provider}
        </div>
        <div className="status">
            {props.Bill.status === "Read" ?
                <span className="status-completed">Concluído</span>
                : <span className="status-pending">Aguardando</span>}
        </div>
        <div className="dateInfo">

            {`Dia ${dateFormatCreate.day} de ${dateFormatCreate.monthName} de ${dateFormatCreate.year}`}
        </div>
        <div className="buttons">
            <Button
                type="button"
                className={`down${!downReady || props.path ? ' load' : ''}`}
                icon={!downReady ? <RiLoader2Line size={18} /> : <FaDownload />}
                text={null}
                func={() => downloadPDF(props.path)}
                disabled={!downReady || props.path === null ? true : false}
            />
        </div>
    </>;
}

export default BillHistoryBox;